import { render, staticRenderFns } from "./customList.vue?vue&type=template&id=4a37d67a&scoped=true"
import script from "./customList.vue?vue&type=script&lang=js"
export * from "./customList.vue?vue&type=script&lang=js"
import style0 from "./customList.vue?vue&type=style&index=0&id=4a37d67a&prod&lang=less"
import style1 from "./customList.vue?vue&type=style&index=1&id=4a37d67a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a37d67a",
  null
  
)

export default component.exports